import Loader from '../../_media/loaders/loader.gif';
import '../CSS/private/Loaders.css';

function SectionLoader({height='650px'}) {
  return (
    <div className='slp-sectionloader' style={{height: height}}>
      <img src={Loader} width='100px' alt='loading bars' />
    </div>
  )
}

export default SectionLoader;